import { render, staticRenderFns } from "./UIBadge.vue?vue&type=template&id=5536993b"
import script from "./UIBadge.vue?vue&type=script&lang=js"
export * from "./UIBadge.vue?vue&type=script&lang=js"
import style0 from "./UIBadge.vue?vue&type=style&index=0&id=5536993b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports